"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var add_icon_dark_svg_1 = __importDefault(require("res/img/add-icon-dark.svg"));
var ProductOptionsCreateBar = function (_a) {
    return (react_1.default.createElement("div", { className: 'products-create-bar flex flex-row' },
        react_1.default.createElement(react_router_dom_1.Link, { to: '/products/options/create', className: 'flex flex-row' },
            react_1.default.createElement("img", { src: add_icon_dark_svg_1.default, alt: 'Create' }),
            react_1.default.createElement("span", null, "Create Option"))));
};
exports.default = ProductOptionsCreateBar;
